import {app} from '../app';

class AdjustFontSizeDirective implements ng.IDirective {

    private window:ng.IWindowService;

    restrict = 'A';

    scope = {
        adjustFontSize: '='
    };

    standardWidth = 1024;
    scale         = 8;

    constructor($window:ng.IWindowService) {
        this.window = $window;
    }

    link(scope, element, attrs) {
        const defaultSize = scope.adjustFontSize,
              minSize     = defaultSize - this.scale,
              maxSize     = defaultSize + this.scale,
              fontRatio   = this.standardWidth / defaultSize;

        angular.element(this.window).resize(() => {
            if (this.window.innerWidth > this.standardWidth) {
                return;
            }

            const base = this.window.innerWidth / fontRatio,
                  size = base > maxSize ? maxSize : (base < minSize ? minSize : base);

            element.css('font-size', size + 'px');
        });
    }

    static factory() {
        const _directive   = ($window:ng.IWindowService) => new this($window);
        _directive.$inject = ['$window'];
        return _directive;
    }

}

app.directive('adjustFontSize', AdjustFontSizeDirective.factory());